import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useRegion } from "@/hooks/useRegion";
import { getConsentDecision, setConsentDecision } from "@/lib/cookieConsent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const { link } = useRegion();

  useEffect(() => {
    const stored = getConsentDecision();
    if (!stored) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    // Also drives the AdSense loader (see src/lib/cookieConsent.js) — accepting here
    // is the only thing that allows the ad script to load at all (§33/§34).
    setConsentDecision(value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:right-auto md:left-6 md:max-w-md z-[100] fade-up"
    >
      <div className="bg-[#0F172A] text-slate-200 rounded-2xl shadow-2xl border border-white/10 p-6">
        <div className="flex items-start gap-3 mb-3">
          <div className="rounded-xl bg-[#10B981]/15 p-2 shrink-0">
            <Cookie size={20} className="text-[#10B981]" />
          </div>
          <div>
            <h4 className="text-white font-semibold font-display">We use cookies</h4>
            <p className="text-sm text-slate-400 mt-1 leading-relaxed">
              We use essential cookies to make this site work, and optional cookies to analyze traffic and improve your
              experience. You can accept or reject non-essential cookies.{" "}
              <Link to={link("/cookie-policy")} className="text-[#10B981] hover:underline">
                Cookie Policy
              </Link>
              .
            </p>
          </div>
        </div>
        <div className="flex gap-3 mt-4">
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="flex-1 rounded-xl bg-[#10B981] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#059669] transition-colors"
          >
            Accept
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => decide("rejected")}
            className="flex-1 rounded-xl border border-white/20 px-4 py-2.5 text-sm font-medium text-slate-200 hover:bg-white/5 transition-colors"
          >
            Reject non-essential
          </button>
        </div>
      </div>
    </div>
  );
}
